var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Timeouts } from '../../framework/Timeouts';
export class ViscaBase {
    constructor(log) {
        this.log = log;
        this.cameraTracking = false;
        this.firmwareVersion = [0x02, 0x02, 0x08, 0x00, 0x25, 0x44, 0x02];
        this.pan = [];
        this.power = [];
        this.tilt = [];
        this.timeouts = new Timeouts();
        this.zoom = [];
        this.asyncHandlers = [
            {
                name: 'addressSet',
                regExp: /\x88\x30\x01/,
                callback: (match) => {
                    this.send([0x88, 0x30, 0x02]);
                },
            },
            {
                name: 'cameraTrackingGet',
                regExp: /([\x81-\x88])\x09\x04\x7d/,
                callback: (match) => {
                    for (const id of this.getIds(match[1])) {
                        this.send([(id + 8) << 4, 0x50, 0, 0, this.cameraTracking ? 0x02 : 0x01, 0]);
                    }
                },
            },
            {
                name: 'cameraTrackingGet.averTr3xx',
                regExp: /([\x81-\x88])\x09\x36\x69\x02/,
                callback: (match) => {
                    for (const id of this.getIds(match[1])) {
                        this.send([(id + 8) << 4, 0x50, 0, this.cameraTracking ? 0x01 : 0x00, 0]);
                    }
                },
            },
            {
                name: 'cameraTrackingSet',
                regExp: /([\x81-\x88])\x01\x04\x7d([\s\S])/,
                callback: (match) => {
                    this.cameraTracking = match[2].charCodeAt(0) === 2;
                    for (const id of this.getIds(match[1])) {
                        this.send([(id + 8) << 4, 0x50]);
                    }
                },
            },
            {
                name: 'cameraTrackingSet.crestronIvCama3',
                regExp: /([\x81-\x88])\x01\x04\x3f\x02([\x50\x51])/,
                callback: (match) => {
                    const isEnabled = match[2].charCodeAt(0) === 0x50;
                    this.cameraTracking = isEnabled;
                    for (const id of this.getIds(match[1])) {
                        this.send([(id + 8) << 4, 0x50]);
                        this.send([0x30, 0x30, 0x30, 0x30, 0x01, isEnabled ? 0x01 : 0x02, 0x01]);
                    }
                },
            },
            {
                name: 'cameraTrackingSet.ptzOpticsG3',
                regExp: /([\x81-\x88])\x0a\x11\x54([\x02\x03])/,
                callback: (match) => {
                    const isEnabled = match[2].charCodeAt(0) === 0x02;
                    this.cameraTracking = isEnabled;
                    for (const id of this.getIds(match[1])) {
                        this.send([(id + 8) << 4, 0x50]);
                    }
                },
            },
            {
                name: 'cameraTrackingSet.alfatron-sdic',
                regExp: /([\x81-\x88])\x0a\x01\x32\x00\x00([\x02\x03])/,
                callback: (match) => {
                    const isEnabled = match[2].charCodeAt(0) === 0x02;
                    this.cameraTracking = isEnabled;
                    for (const id of this.getIds(match[1])) {
                        this.send([(id + 8) << 4, 0x50]);
                    }
                },
            },
            {
                name: 'panTiltGet',
                regExp: /([\x81-\x88])\x09\x06\x12/,
                callback: (match) => {
                    for (const id of this.getIds(match[1])) {
                        this.send([
                            (id + 8) << 4,
                            0x50,
                            ...this.convertPositionToBytes(this.pan[id], 4),
                            ...this.convertPositionToBytes(this.tilt[id], 4),
                        ]);
                    }
                },
            },
            {
                name: 'panTiltDrive',
                regExp: /([\x81-\x88])\x01\x06\x01(.{4})/,
                callback: (match) => __awaiter(this, void 0, void 0, function* () {
                    for (const id of this.getIds(match[1])) {
                        this.send([(id + 8) << 4, 0x50]);
                    }
                }),
            },
            {
                name: 'panTiltSet',
                regExp: /([\x81-\x88])\x01\x06\x02..(.{4})(.{4})/,
                callback: (match) => __awaiter(this, void 0, void 0, function* () {
                    const promises = [];
                    for (const id of this.getIds(match[1])) {
                        this.pan[id] = this.convertPositionToNumber(match[2]);
                        this.tilt[id] = this.convertPositionToNumber(match[3]);
                        promises.push((() => __awaiter(this, void 0, void 0, function* () {
                            yield this.timeouts.delay(2000);
                            this.send([(id + 8) << 4, 0x40]);
                            yield this.timeouts.delay(500);
                            this.send([(id + 8) << 4, 0x50]);
                        }))());
                    }
                    yield Promise.all(promises);
                }),
            },
            {
                name: 'powerGet',
                regExp: /([\x81-\x88])\x09\x04\x00/,
                callback: (match) => {
                    for (const id of this.getIds(match[1])) {
                        this.send([(id + 8) << 4, 0x50, this.power[id] ? 0x02 : 0x03]);
                    }
                },
            },
            {
                name: 'powerSet',
                regExp: /([\x81-\x88])\x01\x04\x00(.)/,
                callback: (match) => {
                    for (const id of this.getIds(match[1])) {
                        this.power[id] = match[2].charCodeAt(0) === 0x02;
                        this.send([(id + 8) << 4, 0x40]);
                        this.send([(id + 8) << 4, 0x50]);
                    }
                },
            },
            {
                name: 'presetSetGet',
                regExp: /([\x81-\x88])\x01\x04\x3f([\x01\x02])([\s\S])/,
                callback: (match) => {
                    for (const id of this.getIds(match[1])) {
                        this.send([(id + 8) << 4, 0x40]);
                        this.send([(id + 8) << 4, 0x50]);
                        // The Crestron IV-CAMA3 uses a special preset to control camera tracking.
                        if (match[2].charCodeAt(0) === 0x01 &&
                            (match[3].charCodeAt(0) === 0x50 || match[3].charCodeAt(0) === 0x51)) {
                            this.cameraTracking = match[3].charCodeAt(0) === 0x50;
                            this.send([
                                0x30,
                                0x30,
                                0x30,
                                0x30,
                                0x01,
                                this.cameraTracking ? 0x01 : 0x02,
                                0x01,
                            ]);
                        }
                    }
                },
            },
            {
                name: 'versionGet',
                regExp: /([\x81-\x88])\x09\x00\x02/,
                callback: (match) => {
                    for (const id of this.getIds(match[1])) {
                        this.send([(id + 8) << 4, 0x50, ...this.firmwareVersion]);
                    }
                },
            },
            {
                name: 'zoomGet',
                regExp: /([\x81-\x88])\x09\x04\x47/,
                callback: (match) => {
                    for (const id of this.getIds(match[1])) {
                        this.send([
                            (id + 8) << 4,
                            0x50,
                            ...this.convertPositionToBytes(this.zoom[id], 4),
                        ]);
                    }
                },
            },
            {
                name: 'zoomSet',
                regExp: /([\x81-\x88])\x01\x04\x47(.{4})/,
                callback: (match) => __awaiter(this, void 0, void 0, function* () {
                    const promises = [];
                    for (const id of this.getIds(match[1])) {
                        this.zoom[id] = this.convertPositionToNumber(match[2]);
                        promises.push((() => __awaiter(this, void 0, void 0, function* () {
                            this.send([(id + 8) << 4, 0x40]);
                            yield this.timeouts.delay(500);
                            this.send([(id + 8) << 4, 0x50]);
                        }))());
                    }
                    yield Promise.all(promises);
                }),
            },
            {
                name: 'invalid',
                regExp: /.+/,
                callback: (match) => {
                    this.send([0x90, 0x60, 0x02]);
                },
            },
        ];
        const [panMax, tiltMax, zoomMax] = [8192, 8192, 8192];
        for (let i = 1; i < 7; i++) {
            this.pan[i] = panMax >> 1;
            this.power[i] = true;
            this.tilt[i] = tiltMax >> 1;
            this.zoom[i] = zoomMax >> 1;
        }
    }
    getIds(data) {
        const id = data.charCodeAt(0) - 0x80;
        if (id >= 1 && id <= 7)
            return [id];
        if (id === 8)
            return [1, 2, 3, 4, 5, 6, 7];
        this.log.error(`invalid id byte: 0x${data.charCodeAt(0).toString(16)}`);
        return [];
    }
    convertPositionToBytes(pos, numBytes) {
        const bytes = [];
        for (let i = 0; i < numBytes; i++) {
            const shift = i * 4;
            bytes.unshift((pos & (0x0f << shift)) >> shift);
        }
        return bytes;
    }
    convertPositionToNumber(data) {
        let value = 0;
        for (let i = 0; i < data.length; i++) {
            value = 16 * value + data.charCodeAt(i);
        }
        return value;
    }
    onConfigure(config) {
        this.timeouts.clearAll();
    }
    onDisconnect() {
        this.timeouts.clearAll();
    }
}
